export enum RoutePath {
  Root = '/',

  Team = '/team',

  // Appointments
  Appointments = '/appointments',

  // Auth
  Login = '/login',
}
